import { Container } from "assets/styles/Layout/Layout.styled";

function Diensten() {
  return (
    <Container marginTop={50}>
      <h1>Diensten</h1>
    </Container>
  )
}

export default Diensten
